// extracted by mini-css-extract-plugin
module.exports = {"productDiv":"Recruit_productDiv__1KAob","productTitleFont":"Recruit_productTitleFont__2aW3o","productFont":"Recruit_productFont__3INLQ"};